/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ElectricityDistributor } from '../models/ElectricityDistributor';
import type { PaginatedElectricityDistributorList } from '../models/PaginatedElectricityDistributorList';
import type { PatchedElectricityDistributor } from '../models/PatchedElectricityDistributor';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsElectricityDistributorsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedElectricityDistributorList
     * @throws ApiError
     */
    public leadsElectricityDistributorsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedElectricityDistributorList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-electricity-distributors/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ElectricityDistributor
     * @throws ApiError
     */
    public leadsElectricityDistributorsCreate({
        requestBody,
    }: {
        requestBody: ElectricityDistributor,
    }): CancelablePromise<ElectricityDistributor> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-electricity-distributors/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ElectricityDistributor
     * @throws ApiError
     */
    public leadsElectricityDistributorsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this electricity distributor.
         */
        id: number,
    }): CancelablePromise<ElectricityDistributor> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-electricity-distributors/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ElectricityDistributor
     * @throws ApiError
     */
    public leadsElectricityDistributorsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this electricity distributor.
         */
        id: number,
        requestBody: ElectricityDistributor,
    }): CancelablePromise<ElectricityDistributor> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-electricity-distributors/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ElectricityDistributor
     * @throws ApiError
     */
    public leadsElectricityDistributorsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this electricity distributor.
         */
        id: number,
        requestBody?: PatchedElectricityDistributor,
    }): CancelablePromise<ElectricityDistributor> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-electricity-distributors/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsElectricityDistributorsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this electricity distributor.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-electricity-distributors/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
